module.exports = __webpack_public_path__ + "img/bg.e2843b9c.png";